import { type ShellElement } from '../../common/shell-element'

export const GOTO_USER_NOTE_SELECTOR = 'goto-user-note-icon'

export type GotoUserNoteIconComponent = ShellElement
